{
  "qr-checkin-success-page": {
    "buttons": {
      "book-now": "BOOK NOW",
      "find-salon": "FIND SALON",
      "salon-page": "SALON BOOKING PAGE"
    },
    "text": {
      "checked-in": "Checked in successfully!",
      "checked-in-hint": "You can book a new appointment for next treatment at any time"
    },
    "meta": {
      "title": "QR Check in",
      "description": "Check in via QR code"
    }
  }
}
